import { UsersRepository } from '../repositories/users.repository'
import {
    BillingGetPeriodsResponseT,
    EmployeePayloadT,
    ProfileResponseT,
    UpdateUserPayloadT,
    UserPayloadT,
    UsersChangeStatusPayload,
    UsersCreateEmployeeResponseT,
    UsersCreateUserResponseT,
    UsersGetDictionaryResponseT,
    UsersGetEmployeeResponseT,
    UsersGetEmployeesFiltersT,
    UsersGetEmployeesResponseT,
    UsersGetInitiatorsParams,
    UsersGetInitiatorsResponseT,
    UsersGetListFilters,
    UsersGetListResponseT,
    UsersGetManagersParams,
    UsersGetManagersResponseT,
    UsersGetTokenResponseT,
    UsersGetUserResponseT,
    UsersUpdateEmployeeResponseT,
    UsersUpdateUserResponseT,
} from '../types/users.types'

const usersRepository = new UsersRepository()

export class UsersService {
    async getList(filters: UsersGetListFilters): Promise<UsersGetListResponseT> {
        const response = await usersRepository.getList(filters)
        return response.data
    }

    async getDictionary(type: number, description?: string): Promise<UsersGetDictionaryResponseT> {
        const response = await usersRepository.getDictionary(type, description)
        return response.data
    }

    async getEmployees(filters: UsersGetEmployeesFiltersT): Promise<UsersGetEmployeesResponseT> {
        const response = await usersRepository.getEmployees(filters)
        return response.data
    }

    async getUserFromCabinet(user_id: number): Promise<UsersGetUserResponseT> {
        const response = await usersRepository.getUserFromCabinet(user_id)
        return response.data
    }

    async getEmployee(id: number): Promise<UsersGetEmployeeResponseT> {
        const response = await usersRepository.getEmployee(id)
        return response.data
    }

    async getDispatchers(
        page: number,
        name?: string,
        limit?: number
    ): Promise<UsersGetListResponseT> {
        const response = await usersRepository.getDispatchers(page, name, limit)
        return response.data
    }

    async getAccountants(
        page: number,
        name?: string,
        statusId?: number
    ): Promise<UsersGetListResponseT> {
        const response = await usersRepository.getAccountants(page, name, statusId)
        return response.data
    }

    async getLogists(
        page: number,
        name?: string,
        isExtended?: number,
        statusId?: number,
        limit?: number
    ): Promise<UsersGetListResponseT> {
        const response = await usersRepository.getLogists(page, name, isExtended, statusId, limit)
        return response.data
    }

    async createUser(payload: UserPayloadT): Promise<UsersCreateUserResponseT> {
        const response = await usersRepository.createUser(payload)
        return response.data
    }

    async createEmployee(payload: EmployeePayloadT): Promise<UsersCreateEmployeeResponseT> {
        const response = await usersRepository.createEmployee(payload)
        return response.data
    }

    async updateUser(
        user_id: number,
        payload: UpdateUserPayloadT
    ): Promise<UsersUpdateUserResponseT> {
        const response = await usersRepository.updateUser(user_id, payload)
        return response.data
    }

    async updateEmployee(
        id: number,
        payload: EmployeePayloadT
    ): Promise<UsersUpdateEmployeeResponseT> {
        const response = await usersRepository.updateEmployee(id, payload)
        return response.data
    }

    async updateUserInCabinet(
        user_id: number,
        payload: UpdateUserPayloadT
    ): Promise<UsersUpdateUserResponseT> {
        const response = await usersRepository.updateUserInCabinet(user_id, payload)
        return response.data
    }

    async deleteUser(user_id: number): Promise<void> {
        await usersRepository.deleteUser(user_id)
    }

    async deleteEmployee(id: number): Promise<void> {
        await usersRepository.deleteEmployee(id)
    }

    async getManagers(params: UsersGetManagersParams): Promise<UsersGetManagersResponseT> {
        const response = await usersRepository.getManagers(params)
        return response.data
    }

    async getInitiators(params: UsersGetInitiatorsParams): Promise<UsersGetInitiatorsResponseT> {
        const response = await usersRepository.getInitiators(params)
        return response.data
    }

    async getBillingPeriods(page: number): Promise<BillingGetPeriodsResponseT> {
        const response = await usersRepository.getBillingPeriods(page)
        return response.data
    }

    async getUserToken(user_id: number): Promise<UsersGetTokenResponseT> {
        const response = await usersRepository.getUserToken(user_id)
        return response.data
    }

    async changeStatus(payload: UsersChangeStatusPayload): Promise<void> {
        const response = await usersRepository.changeStatus(payload)
        return response.data
    }

    async getProfile(): Promise<ProfileResponseT> {
        const response = await usersRepository.getProfile()
        return response.data
    }
}
